import { convertDate } from '@commons/utils/date/date';

export interface OpsEvent {
  id: string;
  status: string;
  activated: boolean | null;
  name: string;
  publicName: string | null;
  description: string;
  type: string;
  campaignId: string;
  clientId: string;
  wizCompanyId: string;
  date: Date;
  scheduleStart: Date | null;
  scheduleEnd: Date | null;
  dateCreated: string | null;
  dateModified: string | null;
  dateSourcingEnd: Date | null;
  timezone: string;
  location: Location;
  address: string;
  venue: string;
  areas: Location[] | null;
  salonUrl: string | null;
  bannerFileId: string | null;
  candidateGuideFileId: string | null;
  invitationPdfFileId: string | null;
  recruiterBadgesFileId: string | null;
  summaryFileId: string | null;
  thumbnailFileId: string | null;
  smallSocialNetworkFileId: string | null;
  bigSocialNetworkFileId: string | null;
  textMessageTemplates: MessageTemplate[];
  mailMessageTemplates: MessageTemplate[];
  templateInvitation: TemplateMail;
  templateReject: TemplateMail | null;
  templateThanks: TemplateMail | null;
  dateOfThanks: string | null;
  confirmedCandidates: number | null;
  requiredCandidates: number | null;
  jobs: JobEvent[];
  fullJobs: JobFullEvent[];
  jobsTitles: string[];
  eventManagers: string[];
  eventOwnerId: string;
  teamMembers: string[];
  lateAttendantsReminder: { tasUserId: string; date: string } | null;
  giftTemplateSent: { tasUserId: string; date: string } | null;
  metaTitle: string;
  metaDescription: string;
  cvBookParameters: CvBookParameters;
  isPlanningGenerated: boolean;
  preventSourcedJobsFromDeletion: boolean;
  nbOfInterviewsACandidateCanAdd: number;
  nbMaxPostulation: number;
  questions: { id: number; content: string }[];
  recruitersSurveyId: string;
  trackedLinks: TrackedLink[];
  trackedLinksDestination: string;
  voipAccountCode: string | null;
}

interface Location {
  geo: Geo;
  city: string;
  cityPlaceId: string;
  address: string | null;
  department: string;
  departmentShort: string;
  zipCode: string;
  state: string;
  stateShort: string;
  country: string;
}

interface Geo {
  lat: number;
  lon: number;
}

interface TemplateMail {
  subject: string;
  content: string;
}

interface CvBookParameters {
  clientName: string | null;
  mainColor: number | null;
  secondaryColor: number | null;
  highlightColor: number | null;
  iconFileId: string | null;
  imageFileId: string | null;
  recipients: (string | null)[];
  interviewDuration: number;
  interviewDebriefingDuration: number;
  interviewBreakDuration: number;
  criteriaGroups: CriteriaGroup[];
  committeeTypes: string[];
}

interface CriteriaGroup {
  id: number;
  name: string;
  criterias: string[];
}

interface TrackedLink {
  id: string;
  description: string;
  url: string;
  linkId: string;
  utm: Utm;
}

interface Utm {
  source?: string;
  medium?: string;
  campaign?: string;
  term?: string;
  content?: string;
}

interface MessageTemplate {
  id: string;
  name: string;
  subject: string;
  messageType: string;
  content: string;
  attachments: unknown[];
}

interface JobEvent {
  name: string;
  contract?: string | null;
  city?: string | null;
  degreeId?: string | null;
  domain?: string | null;
  description?: string | null;
  softSkills: string[];
  salary?: string | null;
  contractDuration?: number | null;
}

interface JobFullEvent {
  name: string;
  domain?: string | null;
  experience?: string | null;
  degreeId?: string | null;
  degree?: string | null;
  effectiveDuration?: string | null;
  contractId?: string | null;
  contract?: Contract | null;
  city?: string | null;
}

interface Contract {
  id: string | null;
  title: string;
  titleShort: string | null;
  duraction: boolean;
  order: number | null;
  locale: string | null;
  computedTitle: string | null;
}

export function toOpsEvent(data: OpsEvent): OpsEvent {
  return {
    ...data,
    scheduleEnd: data.scheduleEnd ? convertDate(data.scheduleEnd) : null,
    dateSourcingEnd: data.dateSourcingEnd ? convertDate(data.dateSourcingEnd) : null,
  };
}
